enum SVG_TYPE {
  ARROW_BACK = 'ARROW_BACK',
  LOGO = 'LOGO',
  LOGO_WHITE = 'LOGO_WHITE',
  EYE = 'EYE',
  EYE_OFF = 'EYE_OFF',
  CHEVRON_SMALL = 'CHEVRON_SMALL',
  CHEVRON_DOWN = 'CHEVRON_DOWN',
  CHEVRON_LEFT = 'CHEVRON_LEFT',
  CHEVRON_RIGHT = 'CHEVRON_RIGHT',
  CHEVRON_TOP = 'CHEVRON_TOP',
  LONG_ARROW = 'LONG_ARROW',
  ALERT = 'ALERT',
  ACCEPT_GREEN = 'ACCEPT_GREEN',
  CLOSE_CIRCLE = 'CLOSE_CIRCLE',
  ELLIPSIS = 'ELLIPSIS',
  USERS = 'USERS',
  USERS_BOLD = 'USERS_BOLD',
  DASHBOARD = 'DASHBOARD',
  ORDERS_LIST = 'ORDERS_LIST',
  EMPLOYEE_RATES = 'EMPLOYEE_RATES',
  ASSEMBLY_MATERIALS = 'ASSEMBLY_MATERIALS',
  LOGOUT = 'LOGOUT',
  CLOSE = 'CLOSE',
  CALENDAR = 'CALENDAR',
  CALENDAR_SECOND = 'CALENDAR_SECOND',
  CALENDAR_PLUS = 'CALENDAR_PLUS',
  DOWNLOAD_FILE = 'DOWNLOAD_FILE',
  PLAY = "PLAY",
  STOP = "STOP",
  PLUS = "PLUS",
  PLUS_CIRCLE = 'PLUS_CIRCLE',
  CLOCK = "CLOCK",
  GO_BACK = 'GO_BACK',
  EDIT = 'EDIT',
  EDIT_SECONDARY = 'EDIT_SECONDARY',
  TEXT = 'TEXT',
  ERASER = 'ERASER',
  TRASH = 'TRASH',
  TRASH_SECOND = 'TRASH_SECOND',
  SEARCH = 'SEARCH',
  BIN = 'BIN',
  EDIT_PENCIL = 'EDIT_PENCIL',
  EXCLAMATION = 'EXCLAMATION',
  EQUAL = 'EQUAL',
  USER = 'USER',
  CHECK_CIRCLE = 'CHECK_CIRCLE',
  CHECK_GREEN = 'CHECK_GREEN',
  WARNING = 'WARNING',
  WARNING_FILL = 'WARNING_FILL',
  RETRY = 'RETRY',
  ARCHIVING = 'ARCHIVING',
  CANCEL = 'CANCEL',
  BLUE_CHECK_CIRCLE = 'BLUE_CHECK_CIRCLE',
  GLOBE = 'GLOBE',
}

export default SVG_TYPE;
